import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useStyles } from "Theme/styles";
import update from "immutability-helper";
import {
  Button,
  LinearProgress,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";

const MessagesContainer = styled.div`
width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
`
const MessageContainer = styled.div`  
  display: flex;
  flex-direction: column;
`

const SendFormContainer = styled.div`
width: 100%;
padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
`
interface ChatTableRow {
  uid: number
  userName: string
  content: string
  timestamp: number
}
interface ChatContainerState {
  tableRows: ChatTableRow[]
  loading: boolean
  sendFieldValue: string
}

const DEFAULT_STATE: ChatContainerState = {
  tableRows:[],
  loading: true,
  sendFieldValue: ""
}
export default function ChatContainer() {
  const [state, setState] = useState<ChatContainerState>(DEFAULT_STATE);
  const { getDatabase } = useContext(AuthContext);
  const { chatState, currentBuilding } = useContext(BuildingContext);
  const classes = useStyles();
  useEffect(() => {
    const tableRows: ChatTableRow[] = []
    for (const key in chatState?.chats) {
      //@ts-ignore
      const chat = chatState?.chats[key]
      if (chat) {
        tableRows.push({
          timestamp: chat.timestamp,
          content: chat.content,
          userName: chat.userName,
          uid: chat.uid
        })
      }
    }
    setState(update(
      state, {
      loading: { $set: false },
        tableRows: { $set: tableRows }
    }
    ))
  }, [chatState]);

  const _handleSendMessage = async () => {
    if(!!getDatabase && state.sendFieldValue !== ""){
      var database = getDatabase();
      await database.ref("buildings/" + currentBuilding?.Id + "/chats").push({
        content: state.sendFieldValue,
        timestamp: Date.now(),
        uid: 0,
        userName: "Console",
      });
      setState({...state, sendFieldValue: ""})
    }
  }
  if(state.loading){
    return <LinearProgress />;
  }else{
    return (<Fragment>
    <MessagesContainer>
      {state.tableRows.map(tableRow => {
      console.log("🚀 ~ file: ChatContainer.tsx ~ line 95 ~ ChatContainer ~ tableRow", tableRow)
        const d = new Date(tableRow.timestamp);
        console.log("🚀 ~ file: ChatContainer.tsx ~ line 97 ~ ChatContainer ~ d", d)
        const time = `${d.getDate()}/${d.getMonth() +
          1}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
        console.log("🚀 ~ file: ChatContainer.tsx ~ line 100 ~ time ~ time", time)
        return <Paper className={tableRow.uid === 0 ? classes.messageSentContainer : classes.messageRecContainer} key={tableRow.timestamp}>
          <MessageContainer>
            <Typography variant="h3">
              {tableRow.content}
            </Typography>
            <Typography color="textPrimary" variant="h6">
              {tableRow.userName}
            </Typography>
            <Typography color="textPrimary" variant="h6">
              {time}
            </Typography>
          </MessageContainer>
        </Paper>
      })}
    </MessagesContainer>
    <SendFormContainer>
        <TextField className={classes.stretchTextField} value={state.sendFieldValue} onChange={(event)=>{setState({...state, sendFieldValue: event.target.value})}}/>
        <Button variant="contained" color="primary" onClick={_handleSendMessage}>Send</Button>
      </SendFormContainer>
    </Fragment>)
  }
  
}
